module.exports = __webpack_public_path__ + "static/media/prostatecancer.50f1e3ae.svg";